import { render } from "./InteractiveVotingResults.vue?vue&type=template&id=094dce64&scoped=true"
import script from "./InteractiveVotingResults.vue?vue&type=script&lang=js"
export * from "./InteractiveVotingResults.vue?vue&type=script&lang=js"

import "./InteractiveVotingResults.vue?vue&type=style&index=0&id=094dce64&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-094dce64"]])

export default __exports__